<template>
    <modal :show="show" @close="close" :closeOnbackdrop="false">
        <template slot="header">
            <h3 v-if="showReject"> Reject Drawing</h3>
            <h3 v-else>
                Verification
                <template v-if="purchaseStep <= purchaseStepLimit">
                    - Step {{ purchaseStep }}/{{ purchaseStepLimit }}
                </template>
                <template v-else-if="purchaseStep == 3">
                    - Confirmation
                </template>
            </h3>
        </template>
        <template>
            <div v-show="purchaseStep == 1">
                <purchase-items @data="setItemChanges" @mounted="get_cars" @done="reviewStep" :items="items" :tax="tax" :tariff="tariff" :dropshipfee="drop_ship_fee" :freightsurcharge="freight_surcharge" :reels="reels" :cars="cars" :project="survey" :done="itemsDone"></purchase-items>
            </div>
            <div v-show="purchaseStep == 2">
                <template v-if="showReject">
                    <div class="row row input-wrap">
                        <div class="col-md-3 text-right">
                            <span class="required-indicator">*</span> Reason:
                        </div>
                        <div class="col-md-9">
                            <input type="text" v-model="reject_reason" required="required" class="form-control">
                        </div>
                    </div>
                    <div class="row row input-wrap">
                        <div class="col-md-3 text-right">Remarked Drawing File(s):</div>
                        <div class="col-md-9">
                            <input type="file" class="form-control" :ref="'reject_files'" accept="application/pdf, image/png, image/gif, image/jpg, image/jpeg" multiple="multiple">
                        </div>
                    </div>
                    <div class="row row input-wrap">
                        <div class="col-md-3 text-right">Note:</div>
                        <div class="col-md-9">Depending on the required change, additional material or design fees may be charged.</div>
                    </div>
                </template>
                <template v-else>
                    <docu-sign :start="startDocusign" :survey_id="survey.id" @status="getDSStatus"></docu-sign>
                </template>
            </div>
            <div v-show="purchaseStep == 3">
                <div class="alert alert-success">
                    <strong>Verified Successfully!</strong>
                </div>
                <iframe :src="'/api/confirmation/'+purchased_id" class="confirmation" v-if="purchased_id"></iframe>
            </div>
        </template>
        <template slot="footer">
            <button v-show="purchaseStep == 2 && showReject" class="btn" type="button" @click="showReject=0">Back</button>
            <button v-show="purchaseStep == 2 && !showReject" class="btn" type="button" @click="prevStep">Back</button>
            <button class="btn btn-black" type="button" :disabled="isStepLoading" @click="nextStep" v-if="purchaseStep < purchaseStepLimit">
                <template v-if="purchaseStep == 1">
                    <template v-if="isStepLoading"><span class="fa fa-spinner fa-pulse"></span></template>
                    <template v-else>Next</template>
                </template>
                <template v-if="purchaseStep == 2">
                    <template v-if="isStepLoading"><span class="fa fa-spinner fa-pulse"></span></template>
                    <template v-else>Verify</template>
                </template>
            </button>
            <button class="btn btn-black" type="button" @click="showReject=1" v-if="purchaseStep == 2 && !showReject">Reject Drawing</button>
            <button class="btn btn-black" type="button" @click="confirmReject" v-if="purchaseStep == 2 && showReject">
                <template v-if="isStepLoading"><span class="fa fa-spinner fa-pulse"></span></template>
                <template v-else>Confirm Reject</template>
            </button>
            <button class="btn btn-black" type="button" :disabled="isStepLoading" @click="nextStep" v-if="purchaseStep == 2 && purchaseStepLimit == 2 && !showReject">
                <template v-if="isStepLoading"><span class="fa fa-spinner fa-pulse"></span></template>
                <template v-else>Verify</template>
            </button>
        </template>
    </modal>
</template>
<script>
import PurchaseItems from '../../components/PurchaseItems.vue'
import DocuSign from '../../components/DocuSign.vue'

export default {
    data() {
        return {
            user: {},
            showConfirm: false,
            showReject: 0,
            isStepLoading: false,
            purchased_id: false,
            purchaseStep: 1,
            purchaseStepLimit: 2,
            startDocusign: false,
            DSStatus: null,
            itemsDone: false,
            shippingDetailSelectDone: false,
            shippingDetail: {},
            paymentMethodSelectDone: false,
            paymentMethod: {},
            cars: [],
            items: [],
            tax: 0,
            tariff: 0,
            drop_ship_fee: 0,
            freight_surcharge: 0,
            itemChanges: false,
            customer_details: {},
            po_by_car: false,
            reject_reason: '',
            reject_files: '',
        }
    },
    components: {
        PurchaseItems,
        DocuSign,
    },
    props: {
        show: Boolean,
        survey: {
            type: [String, Object, Array, Boolean],
            default: "",
            description: "Model"
        },
    },
    watch: {
        show() {
            console.log('watch','show');
            this.purchaseStep = 1;
            this.get_cars();
        },
        survey: {
            handler: function(data) {
                this.reject_reason = '';
                this.reject_files = '';
                console.log('watch',data);
                console.log('data-purch',data);
                if ( data.status == 'REQUESTED' ) {
                        this.DSStatus = 'completed';
                        this.pdf_ds_documents = data.pdf_ds_documents;
                }
            }
        }
    },
    mounted() {
        this.get_customer_details()
    },
    methods: {
        nextStep() {
            let now = new Date

            switch(this.purchaseStep) {
                case 1: { // Review
                    if(!this.itemsDone) {
                        alert('Please check "I reviewed all the Items listed above."');
                        return false;
                    } else if ( !this.itemChanges.hastotal ) {
                        alert('Please check at least 1 item with price.');
                        return false;
                    } 
                    /*var inactive = false,
                        item = false;
                    for ( var cn in this.items ) {
                        for ( var g in this.items[cn] ) {
                            for ( var i in this.items[cn][g] ) {
                                item = this.items[cn][g][i];
                                if ( item.isactive === false && item.exclude !== false ) {
                                    inactive = true;
                                }
                            }
                        }
                    }
                    if ( inactive ) {
                        if ( !confirm('You left checked some inactive items (items in Red), this will go CUSTOM, still want to proceed?') ) {
                            return false;
                        }
                    }*/

                    this.$http.post('/api/purchase/presave/'+this.survey.id, this.itemChanges);
                    if(!this.DSStatus) {
                        this.startDocusign = now.getTime()
                    }
                    this.purchaseStep = 2
                    break;
                }
                case 2: { // Docusign
                    // this.isStepLoading = true
                    // setTimeout(() => {
                    //     this.isStepLoading = false
                    // }, 1000)

                    if( this.DSStatus == 'completed' ) {
                        this.isStepLoading = true;
                        var statstep = this.user.can_purchase == 3 ? 'order' : 'verify';
                        // Purchase
                        this.$http.post('/api/settings/'+statstep+'/'+this.survey.id)
                            .then((response) => {
                                console.log('Verification response:',response);
                                if ( response.data.status == 'CUSTOM' ) {
                                    alert(response.data.message);
                                } else {
                                    var statmsg = this.user.can_purchase == 3 ? 'Request' : 'Verification';
                                    alert(statmsg+' Successfull!');
                                }
                                this.close();
                                this.$emit('reload', true);
                                this.isStepLoading = false;
                            })
                            .catch((error) => {
                                alert(error.response.data.message)
                                this.isStepLoading = false
                            })
                    } else {
                        alert('Complete the Docusign process first!');
                    }
                    break;
                }
                case 3: { // Verification
                    break;
                }
            }
        },
        setItemChanges({changes}) {
            console.log('changes',changes);
            this.itemChanges = changes;
        },
        reviewStep({reviewed}) {
            this.itemsDone = reviewed;
        },
        prevStep() {
            if(this.purchaseStep > 1) {
                this.purchaseStep--
            }
        },
        getPaymentMethod(data) {
            this.paymentMethod = data
        },
        confirmReject() {
            let fdata = new FormData(),
                hasNoFile = true;
            if ( !this.reject_reason ) {
                alert('Please fill the Reason for rejection.');
                return false;
            }
            fdata.append('survey_id', this.survey.id);
            fdata.append('reason', this.reject_reason);
            if(this.$refs.reject_files != undefined) {
                for( var i = 0; i < this.$refs.reject_files.files.length; i++ ){
                    let file = this.$refs.reject_files.files[i];
                    fdata.append('reject_files[' + i + ']', file);
                    hasNoFile = false;
                }
            }
            if ( hasNoFile ) {
                fdata.append('reject_files', 0);
                if ( !confirm('Are you sure you want to reject without the Remarked Drawing File(s)?') ) {
                    return false;
                }
            }
            this.isStepLoading = true;
            // Purchase
            this.$http.post('/api/settings/reject/'+this.survey.id, fdata, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                console.log('reject response',response)
                this.isStepLoading = false;
                this.$emit('reload', true);
                this.close();
            })
            .catch((error) => {
                alert(error.response.data.message)
                this.isStepLoading = false
            })
        },
        getDSStatus(status) {
            this.DSStatus = status
            if(status == 'completed') {

                if ( this.purchaseStepLimit == 2) {
                    this.showConfirm = true;
                    /*this.isStepLoading = true;
                    // Purchase
                    this.$http.post('/api/settings/order/'+this.survey.id)
                        .then((response) => {
                            // alert('Purchase Request has been submitted.');
                            console.log(response);
                            this.purchased_id = this.survey.id;
                            this.$emit('reload', true);
                            this.purchaseStep = 4;
                            this.isStepLoading = false;
                        })
                        .catch((error) => {
                            alert(error.response.data.message)
                            this.isStepLoading = false
                        })*/
                } else {
                    this.purchaseStep = 3
                }
            }
        },
        getShippingDetail(data) {
            this.shippingDetail = data
        },
        close() {
            this.show = false
            this.$emit('close', true)
        },
        get_cars() {
            this.showConfirm = false;
            console.log('get car', this.survey.id);
            console.log('purch data', this.survey);
            if ( this.survey.status == 'REQUESTED' && this.survey.pdf_ds_documents ) {
                this.DSStatus = 'completed';
                this.pdf_ds_documents = this.survey.pdf_ds_documents;
            }
            if(this.survey.id != undefined) {
                this.$http.get('/api/settings/project_cars/' + this.survey.id)
                    .then((response) => {
                        this.cars = response.data.inputs;
                        this.items = response.data.items;
                        this.tax = response.data.tax;
                        this.tariff = response.data.tariff;
                        this.drop_ship_fee = response.data.drop_ship_fee;
                        this.freight_surcharge = response.data.freight_surcharge;
                        this.reels = response.data.reels;
                    })
            }
        },
        get_customer_details() {

            var user = localStorage.getItem('user');
            this.user = JSON.parse(user);

            // this.purchaseStepLimit = this.user.can_purchase == 3 ? 2 : 4;

            this.$http.get('/api/purchase/get-details', { id: this.survey.id })
                .then((response) => {
                    this.customer_details = response.data
                })
        },
        getPoByCar(n) {
            this.po_by_car = n
        }
    }
}
</script>
<style lang="scss" scoped>
.confirmation { width: 100%; height: calc(100vh -  317px); }
.modal::v-deep {
    .modal-dialog {
        max-width: 98%;
    }
}
.input-wrap {
    padding: 2px 10px;
}
</style>